// Canonical Widget User Event payload factories (US1918962, Epic 11).
// See PRD §3.5.1 and BR-WUE-001..005 for the dictionary contract.
//
// Each factory returns a payload object suitable for passing as the third
// argument to trackEvent(widgetName, windowId, payload). Factories do not
// call trackEvent themselves — call sites still own widgetName/windowId via
// useRequestData() in the standard way.
//
// widgetState follows view-mode semantics (BR-WUE-002): detail-view events
// emit widgetState='detail'; viewInventoryEvent takes originView so the
// same CTA can fire from either view with the correct widgetState.

export const facetAccordionEvent = ({ heading, expanded }) => ({
	element: `${heading} accordion`,
	action: expanded ? 'expanded' : 'collapsed',
	result: expanded ? 'Accordion expanded' : 'Accordion collapsed',
	widgetState: 'default',
	nonInteractive: false
});

export const facetSelectionEvent = ({ heading, value, applied }) => ({
	element: `${heading} selection`,
	elementCTA: value,
	action: applied ? 'applied' : 'removed',
	result: applied
		? 'Results updated with facet added'
		: 'Results updated with facet removed',
	widgetState: 'default',
	fieldValue: value,
	nonInteractive: false
});

export const facetChipRemoveEvent = ({ heading, value }) => ({
	element: `${heading} chip`,
	elementCTA: value,
	action: 'removed',
	result: 'Results updated with facet removed',
	widgetState: 'default',
	nonInteractive: false
});

export const clearAllEvent = ({ label }) => ({
	element: 'Clear all button',
	elementCTA: label,
	action: 'clicked',
	result: 'Results updated with facet selections removed',
	widgetState: 'default',
	nonInteractive: false
});

export const mobileShowVehiclesEvent = ({ liveFilterCount }) => ({
	element: 'Show vehicles button',
	elementCTA: `Show "${liveFilterCount}" Incentives`,
	action: 'clicked',
	result: 'Facet screen hidden and results shown',
	widgetState: 'default',
	nonInteractive: false
});

export const detailTabClickEvent = ({ tabLabel }) => ({
	element: `${tabLabel} tab`,
	elementCTA: tabLabel,
	action: 'clicked',
	result: 'Tab displayed',
	widgetState: 'detail',
	nonInteractive: false
});

export const requestMoreInfoEvent = ({ label }) => ({
	element: 'Request more info button',
	elementCTA: label,
	action: 'clicked',
	result: 'Lead form opened',
	widgetState: 'detail',
	nonInteractive: false
});

// originView: 'default' | 'detail' — set by the call site to reflect the
// view the CTA fires from (BR-WUE-002).
export const viewInventoryEvent = ({ label, originView }) => ({
	element: 'View Inventory button',
	elementCTA: label,
	action: 'clicked',
	result: 'Navigated to filtered SRP',
	widgetState: originView,
	nonInteractive: false
});

// fieldValue is a deterministic stringification of activeFilters in
// FACET_KEYS order: "key:value,key:value,...". Empty filters → "".
const FACET_KEYS_ORDER = ['offerTypes', 'year', 'bodyStyle', 'make', 'model'];

export const backToIncentivesEvent = ({ label, activeFilters }) => {
	const fieldValue = FACET_KEYS_ORDER.flatMap((key) =>
		((activeFilters && activeFilters[key]) || []).map((v) => `${key}:${v}`)
	).join(',');
	return {
		element: 'Back to incentives link',
		elementCTA: label,
		action: 'clicked',
		result: 'Navigated to Global Incentives page',
		widgetState: 'detail',
		fieldValue,
		nonInteractive: false
	};
};
